import React, { useContext, useEffect, useState } from 'react'
import { AuthContext, ThemeContext } from '../../../../auth';
import { Button, Card, Col, Form, InputGroup, Modal, Row, Spinner } from 'react-bootstrap';
import Select from 'react-select';
import { IoMdAddCircle } from 'react-icons/io';
import { useMediaQuery } from 'react-responsive';
import Swal from 'sweetalert2';
import { IoAddCircle } from "react-icons/io5";
import { MdDeleteForever } from "react-icons/md";
import { axiosAuth } from '../../../../api';

function ModalTambahLead({
    showTambahLead,
    setShowTambahLead,
    retrieveLead,
    accessToken
}) {

    const { userInfo } = useContext(AuthContext);
    const { theme } = useContext(ThemeContext);
    const [tanggalLead, setTanggalLead] = useState('');
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [selectedStatusLead, setSelectedStatusLead] = useState(null);
    const [selectedRequest, setSelectedRequest] = useState(null);
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const [disabled, setDisabled] = useState(false);
    const [isSubmittingLead, setIsSubmittingLead] = useState(false);
    const [listCompany, setListCompany] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [listCustomer, setListCustomer] = useState([]);

    const retrieveCustomer = () => {

        axiosAuth.get(`/api/customers`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,
                },

            })
            .then(res => {

                setListCustomer(res.data.data);

            }).catch(err => {

                console.error(err)
            })
    };

    useEffect(() => {
        if (accessToken !== undefined) retrieveCustomer();
    }, [accessToken]);

    const handleClose = () => {
        setShowTambahLead(false);
        setTanggalLead('');
        setSelectedCustomer(null);
        setSelectedStatusLead(null);
        setSelectedRequest(null);
        setSelectedCompany(null);
    };

    const leadStatusOptions = [
        {
            value: 10,
            label: 'Perkenalan - 10%',
        },
        {
            value: 25,
            label: 'Info Kebutuhan - 25%',
        },
        {
            value: 50,
            label: 'Buat PCP - 50%',
        },
        {
            value: 0,
            label: 'Gagal - 0%',
        },
    ];

    const customerOptions = listCustomer.map(cust => ({
        value: cust.id,
        label: cust?.title?.titleName === "Others"
            ? cust?.name
            : `${cust?.title?.titleName}. ${cust?.name}`,
    }));

    const handleSelectCustomer = (selectedOption) => {
        setSelectedCustomer(selectedOption);
    };

    const handleSelectLeadStatus = selectedOption => {
        setSelectedStatusLead(selectedOption);
    };

    const requestOptions = [
        {
            value: 'penjualan',
            label: 'Penjualan',
        },
        {
            value: 'sewa',
            label: 'Sewa',
        },
    ];

    const handleSelectRequest = (selectedOption) => {
        setSelectedRequest(selectedOption);
    };

    const retrieveCompany = () => {

        axiosAuth.get(`/api/companies`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,
                },

            })
            .then(res => {

                setListCompany(res.data.data);

            }).catch(err => {
                console.error(err);

            })
    };

    useEffect(() => {
        if (accessToken !== undefined) retrieveCompany();
    }, [accessToken]);

    const companyOptions = listCompany.map(company => ({
        value: company.id,
        label: 'PT. ' + company?.companyName,
    }));

    const handleSelectCompany = (selectedOption) => {
        setSelectedCompany(selectedOption);
    };

    const handleSubmitLead = async (event) => {

        event.preventDefault();

        setIsSubmittingLead(true);
        setDisabled(true);

        const dataLead = {
            date: tanggalLead,
            customerId: selectedCustomer?.value,
            companyId: selectedCompany?.value,
            status: selectedStatusLead?.value,
            username: userInfo?.username,
            createdBy: parseInt(userInfo?.id),
            firstName: userInfo?.firstName,
            orderType: selectedRequest?.value || null
        }

        try {

            const response = await axiosAuth.post(`/api/leads`, dataLead, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`
                },
            });

            handleClose();

            Swal.fire({
                icon: 'success',
                title: 'Berhasil menambahkan Lead',
                showConfirmButton: true,
            });
            retrieveLead();
            setIsSubmittingLead(false);
            setDisabled(false);

        } catch (err) {
            console.error(err);

            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Terjadi kesalahan saat menambahkan Lead',
            });

            setIsSubmittingLead(false);
            setDisabled(false);

        } finally {

            setIsSubmittingLead(false);
            setDisabled(false);

        }

    };

    const getTodayDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const formStyles = {
        label: {
            fontFamily: 'Poppins-Medium',
            color: theme === 'light' ? '#FFFFFF' : '#222222',
        },
        input: {
            color: theme === 'light' ? '#FFFFFF' : '#222222',
            fontFamily: 'Poppins-Regular',
            minHeight: '50px',
            borderColor: '#ced4da',
        },
    };

    const selectStyles = {
        control: (cityided, state) => ({
            ...cityided,
            minHeight: '50px',
            border: state.isFocused ? '1px solid #80bdff' : '1px solid #ced4da',
            boxShadow: state.isFocused ? '0 0 0 0.3rem rgba(0, 123, 255, 0.25)' : null,
            '&:hover': {
                borderColor: '#80bdff',
            },
            borderTopRightRadius: '0px',
            borderBottomRightRadius: '0px',
            textAlign: 'left',
            fontFamily: 'Poppins-Regular',
            background: theme === 'light' ? '#212529' : '#FFFFFF',

        }),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected ? '#fff' : '#333',
            background: state.isSelected ? '#007bff' : state.isFocused ? '#f5f5f5' : '#fff',
            fontFamily: 'Poppins-Regular',
        }),
        singleValue: (provided) => ({
            ...provided,
            color: theme === 'light' ? '#FFFFFF' : '#222',
            fontFamily: 'Poppins-Regular',
        }),
        input: (provided) => ({
            ...provided,
            color: theme === 'light' ? '#FFFFFF' : '#222',
            fontFamily: 'Poppins-Regular',
        }),
    };

    return (
        <Modal
            show={showTambahLead}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            size='md'
            centered
            data-bs-theme={theme === 'light' ? 'dark' : ''}
        >
            <Modal.Header closeButton >
                <Modal.Title style={{ fontFamily: 'Poppins-Medium', color: theme === 'light' ? '#FFFFFF' : '#222222', }}>
                    Tambah Lead
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmitLead}>
                    <Form.Group className="mb-3">
                        <Form.Label style={formStyles.label} htmlFor='date'>Tanggal*</Form.Label>
                        <Form.Control
                            id='date'
                            type='date'
                            onChange={(e) => setTanggalLead(e.target.value)}
                            value={tanggalLead}
                            // min={getTodayDate()}
                            required
                            style={formStyles.input}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label style={formStyles.label} htmlFor='customer'>Customer*</Form.Label>
                        <Select
                            id='customer'
                            options={customerOptions}
                            required
                            value={selectedCustomer}
                            onChange={handleSelectCustomer}
                            styles={selectStyles}
                            placeholder='Pilih Customer'
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label style={formStyles.label} htmlFor='company'>Perusahaan*</Form.Label>
                        <Select
                            id='company'
                            options={companyOptions}
                            required
                            value={selectedCompany}
                            onChange={handleSelectCompany}
                            styles={selectStyles}
                            placeholder='Pilih Perusahaan'
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label style={formStyles.label} htmlFor='request'>Tipe Transaksi</Form.Label>
                        <Select
                            id='request'
                            options={requestOptions}
                            value={selectedRequest}
                            onChange={handleSelectRequest}
                            placeholder='Pilih Tipe Transaksi'
                            styles={selectStyles}
                        />
                    </Form.Group>
                    <Form.Group className="mb-4">
                        <Form.Label style={formStyles.label} htmlFor='status'>Status Lead*</Form.Label>
                        <Select
                            id='status'
                            options={leadStatusOptions}
                            required
                            value={selectedStatusLead}
                            onChange={handleSelectLeadStatus}
                            styles={selectStyles}
                            placeholder='Pilih Status Lead'
                        />
                    </Form.Group>
                    <div className="d-grid gap-2 my-2">
                        {isSubmittingLead ? (
                            <Button
                                id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                variant='btn'
                                disabled
                            >
                                <Spinner
                                    animation="border"
                                    size='sm'
                                />
                            </Button>
                        ) : (
                            <Button
                                type="submit"
                                id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                variant='btn'
                                disabled={
                                    disabled ||
                                    !tanggalLead ||
                                    !selectedStatusLead ||
                                    !selectedCustomer
                                }
                            >
                                Simpan
                            </Button>
                        )}
                    </div>
                </Form>
            </Modal.Body>

        </Modal>
    )
}

export default ModalTambahLead